import React from 'react';
import './About.scss';
import Photos from './Common/Photo';
import Features from './Common/Features';
import Reviews from './Common/Reviews';
import Documents from './Common/Documents';
import Map from './Common/Map';

function About() {
  return (
    <div>
      <Photos />
      <Features />
      <Reviews />
      <Documents />
      <Map />
    </div>
  );
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About/About.jsx